import React, { useEffect, useState } from 'react';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';

export interface ITextRangeFilter {
    filter: any;
    onFilterChange: (filterId: number, value: any, debounced?: boolean) => void;
    className?: string;
}

export const TextRangeFilter: React.FC<ITextRangeFilter> = (props): JSX.Element => {
    const { filter, onFilterChange, className } = props;
    const { t } = useTranslation();

    const _value: number[] = filter.value !== null ? filter.value : filter.values;
    let units = filter.settingsFilter?.units?.inputs || '';

    const [ inputsValues, setInputsValues ] = useState<(string | number)[]>(_value);

    if (units === 'руб.') {
        units = 'руб';
    }

    useEffect(() => {
        if (filter.value === null) {
            setInputsValues(_value);
        }
    }, _value);

    const handleChange = (value: string, from = true) => {
        const val = Number(value);
        let newValue: (string | number)[] = from ? [ value, inputsValues[1] ] : [ inputsValues[0], value ];
        setInputsValues(newValue);
        // newValue = [ ..._value ];
        // Попадаем ли в ограничения
        // let strVal = ((val < filter.values[0]) && (value !== '')) ? filter.values[0] : value;
        // strVal = ((val > filter.values[1]) && (value !== '')) ? filter.values[1] : strVal;
        // // newValue = [ ..._value ];
        // newValue = from ? [ strVal, newValue[1] ] : [ newValue[0], strVal ];

        // newValue = newValue.map(v => Number(v));
        newValue = newValue.map(v => (v === '' ? null : Number(v)));
        // Совпадает ли значение с ограничениями
        // newValue = (newValue[0] === filter.values[0]) && (newValue[1] === filter.values[1]) ? null : newValue;
        onFilterChange(filter.id, newValue, true);
    };


    return (
        <div className={clsx('objects-filter', 'objects-filter-text-range', className)}>
            <div className="objects-filter__name">{ `${filter.name}${units ? `, ${t(units)}` : ''}` }</div>
            <div className="objects-filter-text-range__control">
                {/* <span>{t('от')}</span> */}
                <div className="objects-filter-text-range__control-input-wrapper">
                    <input
                        type="number"
                        value={inputsValues[0]}
                        onChange={e => handleChange(e.target.value)}
                        min={filter.values[0]}
                        max={filter.values[1]}
                    />
                </div>
                {/* <span>{t('до')}</span> */}
                <div className="objects-filter-text-range__control-input-wrapper">
                    <input
                        type="number"
                        value={inputsValues[1]}
                        onChange={e => handleChange(e.target.value, false)}
                        min={filter.values[0]}
                        max={filter.values[1]}
                    />
                </div>
                {/* <span>{t(units)}</span> */}
            </div>
        </div>
    );
};
